 
const formatCurrency = (value) => {
  if (value === null || value === undefined) return '';

  let numeric;

  if (typeof value === 'number') {
    if (Number.isNaN(value)) return '';
    numeric = value;
  } else {
    const raw = String(value).trim();
    if (raw.length === 0) return '';
    const normalized = raw
      .replace(/[^\d,.-]/g, '')
      .replace(/(?!^)-/g, '') 
      .replace(/,/g, '.')
      .replace(/\.(?=.*\.)/g, '');

    numeric = Number(normalized);
    if (Number.isNaN(numeric)) return raw; 
  }

  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numeric);
}

export default formatCurrency;